import request from '@/utils/request'

// 刷题用户

let StudyUserApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.study_user/lists', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.study_user/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.study_user/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.study_user/edit', data, errorback);
    },
}

export default StudyUserApi;



// WEBPACK FOOTER //
// ./src/api/study/study_user.js